import * as i0 from '@angular/core';
import { inject, signal, Injectable, input, effect, Component, EventEmitter, Output, Input, ViewChild, ViewEncapsulation, computed, viewChild, model, ElementRef, Directive, ChangeDetectionStrategy } from '@angular/core';
import * as i1 from '@angular/forms';
import { FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import * as i1$1 from '@angular/common';
import { NgIf, NgClass, NgForOf, CommonModule } from '@angular/common';
import { PhoneNumberUtil, PhoneNumber, PhoneNumberFormat, PhoneNumberType } from 'google-libphonenumber';
function CdsSvgIconComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r0.svgIcon(), i0.ɵɵsanitizeHtml);
  }
}
const _c0 = ["addressAutocomplete"];
function CdsInputPlacesComponent_div_4_ng_container_1_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const label_r4 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(label_r4);
  }
}
function CdsInputPlacesComponent_div_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "cds-svg-icon", 8);
    i0.ɵɵtemplate(2, CdsInputPlacesComponent_div_4_ng_container_1_span_2_Template, 2, 1, "span", 9);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.options == null ? null : ctx_r2.options.locateMe == null ? null : ctx_r2.options.locateMe.label);
  }
}
function CdsInputPlacesComponent_div_4_ng_template_2_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const label_r5 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(label_r5);
  }
}
function CdsInputPlacesComponent_div_4_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 11);
    i0.ɵɵtemplate(1, CdsInputPlacesComponent_div_4_ng_template_2_span_1_Template, 2, 1, "span", 9);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.options == null ? null : ctx_r2.options.locateMe == null ? null : ctx_r2.options.locateMe.inProgressLabel);
  }
}
function CdsInputPlacesComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵlistener("click", function CdsInputPlacesComponent_div_4_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.getLocation());
    });
    i0.ɵɵtemplate(1, CdsInputPlacesComponent_div_4_ng_container_1_Template, 3, 1, "ng-container", 7)(2, CdsInputPlacesComponent_div_4_ng_template_2_Template, 2, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const inProgress_r6 = i0.ɵɵreference(3);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.locationInProgress)("ngIfElse", inProgress_r6);
  }
}
const _c1 = ["*"];
function CdsCheckboxComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 6);
    i0.ɵɵlistener("click", function CdsCheckboxComponent_Conditional_4_Template_svg_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      i0.ɵɵnextContext();
      const checkbox_r3 = i0.ɵɵreference(3);
      return i0.ɵɵresetView(checkbox_r3.click());
    });
    i0.ɵɵelement(1, "path", 7);
    i0.ɵɵelementEnd();
  }
}
const _c2 = (a0, a1) => [a0, a1];
function CdsProgressBarComponent_span_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 5);
    i0.ɵɵlistener("click", function CdsProgressBarComponent_span_4_Template_span_click_0_listener() {
      const i_r2 = i0.ɵɵrestoreView(_r1).index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.clickOnCircle(i_r2 + 1));
    });
    i0.ɵɵelementStart(1, "span", 6);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const choice_r4 = ctx.$implicit;
    const i_r2 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c2, i_r2 + 1 === ctx_r2.selected ? "selected" : "", ctx_r2.isOver(i_r2, ctx_r2.selected, ctx_r2.orientation) ? "over" : "under"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(choice_r4.text);
  }
}
function CdsBadgeInfoComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cds-svg-icon", 1);
  }
  if (rf & 2) {
    i0.ɵɵproperty("name", ctx);
  }
}
const _c3 = ["cdsLocalizedInput"];
const _c4 = ["input"];
const _c5 = a0 => ({
  "open": a0
});
function CdsInputLocalizedComponent_div_0_img_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 12);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("src", ctx_r1.country.flagUrl, i0.ɵɵsanitizeUrl)("alt", ctx_r1.country.countryISO);
  }
}
function CdsInputLocalizedComponent_div_0_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.country.countryISO.toUpperCase());
  }
}
function CdsInputLocalizedComponent_div_0_p_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("+", ctx_r1.country.countryCode, "");
  }
}
function CdsInputLocalizedComponent_div_0_cds_svg_icon_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cds-svg-icon", 13);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c5, ctx_r1.selectOpen))("name", "expand");
  }
}
function CdsInputLocalizedComponent_div_0_div_11_li_2_img_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 12);
  }
  if (rf & 2) {
    const country_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("src", country_r4.flagUrl, i0.ɵɵsanitizeUrl)("alt", country_r4.countryISO);
  }
}
function CdsInputLocalizedComponent_div_0_div_11_li_2_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const country_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("(+", country_r4.countryCode, ")");
  }
}
function CdsInputLocalizedComponent_div_0_div_11_li_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 16);
    i0.ɵɵlistener("click", function CdsInputLocalizedComponent_div_0_div_11_li_2_Template_li_click_0_listener() {
      const country_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onCountryChanged(country_r4));
    });
    i0.ɵɵtemplate(1, CdsInputLocalizedComponent_div_0_div_11_li_2_img_1_Template, 1, 2, "img", 17);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CdsInputLocalizedComponent_div_0_div_11_li_2_div_4_Template, 2, 1, "div", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const country_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", country_r4.flagUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(country_r4.localizedName);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", country_r4.countryCode);
  }
}
function CdsInputLocalizedComponent_div_0_div_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "ul");
    i0.ɵɵtemplate(2, CdsInputLocalizedComponent_div_0_div_11_li_2_Template, 5, 3, "li", 15);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.countries());
  }
}
function CdsInputLocalizedComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4, 0)(2, "div", 5)(3, "div", 6);
    i0.ɵɵlistener("click", function CdsInputLocalizedComponent_div_0_Template_div_click_3_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSelectedCountryClick());
    });
    i0.ɵɵtemplate(4, CdsInputLocalizedComponent_div_0_img_4_Template, 1, 2, "img", 7)(5, CdsInputLocalizedComponent_div_0_ng_template_5_Template, 2, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(7, CdsInputLocalizedComponent_div_0_p_7_Template, 2, 1, "p", 8)(8, CdsInputLocalizedComponent_div_0_cds_svg_icon_8_Template, 1, 4, "cds-svg-icon", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "input", 10, 2);
    i0.ɵɵlistener("input", function CdsInputLocalizedComponent_div_0_Template_input_input_9_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onValueChange($event));
    })("change", function CdsInputLocalizedComponent_div_0_Template_input_change_9_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleDefaultChangeEvent($event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(11, CdsInputLocalizedComponent_div_0_div_11_Template, 3, 1, "div", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const countryText_r5 = i0.ɵɵreference(6);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r1.country.flagUrl)("ngIfElse", countryText_r5);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.country.countryCode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.expandable());
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", (ctx_r1.value == null ? null : ctx_r1.value.value) || "")("type", ctx_r1.inputType)("dir", ctx_r1.containsArabic || ctx_r1.placeholderContainsArabic ? "rtl" : "ltr")("placeholder", ctx_r1.country.placeholder)("disabled", ctx_r1.disabled());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.selectOpen);
  }
}
const _c6 = ["cdsTelInput"];
const _c7 = ["cdsButton", ""];
var CdsInputPlacesError = /*#__PURE__*/function (CdsInputPlacesError) {
  CdsInputPlacesError["PERMISSION_DENIED"] = "PERMISSION_DENIED";
  CdsInputPlacesError["POSITION_UNAVAILABLE"] = "POSITION_UNAVAILABLE";
  CdsInputPlacesError["INVALID_PLACE_FOUND"] = "INVALID_PLACE_FOUND";
  CdsInputPlacesError["UNKNOWN"] = "UNKNOWN";
  return CdsInputPlacesError;
}(CdsInputPlacesError || {});
let SvgIconService = /*#__PURE__*/(() => {
  class SvgIconService {
    constructor() {
      this.httpClient = inject(HttpClient);
      this.sanitizer = inject(DomSanitizer);
      this.cache = new Map();
    }
    add(urlKey) {
      if (!this.cache.has(urlKey)) {
        this.cache.set(urlKey, signal(undefined));
        firstValueFrom(this.httpClient.get(urlKey, {
          responseType: 'text'
        })).then(response => {
          this.cache.get(urlKey)?.set(this.sanitizer.bypassSecurityTrustHtml(response));
        });
      }
      return this.get(urlKey);
    }
    get(key) {
      return this.cache.get(key)?.asReadonly();
    }
    static {
      this.ɵfac = function SvgIconService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SvgIconService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: SvgIconService,
        factory: SvgIconService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return SvgIconService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CdsSvgIconComponent = /*#__PURE__*/(() => {
  class CdsSvgIconComponent {
    constructor() {
      this.service = inject(SvgIconService);
      this.name = input();
      this.path = input();
      effect(() => {
        const url = this.path() || `assets/icons/${this.name()}.svg`;
        const cache = this.service.get(url);
        if (cache) {
          this.svgIcon = cache;
        } else {
          this.svgIcon = this.service.add(url);
        }
      });
    }
    static {
      this.ɵfac = function CdsSvgIconComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CdsSvgIconComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CdsSvgIconComponent,
        selectors: [["cds-svg-icon"]],
        inputs: {
          name: [1, "name"],
          path: [1, "path"]
        },
        decls: 1,
        vars: 1,
        consts: [[3, "innerHTML"]],
        template: function CdsSvgIconComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CdsSvgIconComponent_Conditional_0_Template, 1, 1, "span", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.svgIcon && ctx.svgIcon() ? 0 : -1);
          }
        },
        styles: ["span[_ngcontent-%COMP%]{width:inherit;height:inherit}"]
      });
    }
  }
  return CdsSvgIconComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CdsInputPlacesComponent = /*#__PURE__*/(() => {
  class CdsInputPlacesComponent {
    constructor() {
      this.placeholder = '';
      this.onError = new EventEmitter();
      this.locationSupported = navigator.geolocation != null;
      this.locationInProgress = false;
      this.disabled = false;
      this.touched = false;
      // Methods to implements control value accessor
      this.propagateChange = _ => {};
      this.onTouched = () => {};
    }
    get value() {
      return this._value;
    }
    set value(v) {
      if (v !== this._value) {
        this._value = v;
        this.propagateChange(this._value);
      }
    }
    registerOnChange(fn) {
      this.propagateChange = fn;
    }
    writeValue(v) {
      this._value = v;
      this.address = CdsInputPlacesComponent.placeToAddress(v);
    }
    registerOnTouched(fn) {}
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
    }
    ngOnChanges(changes) {
      const options = changes['options']?.currentValue;
      if (options) {
        if (options?.locateMe?.enabled && this.locationSupported) {
          this.geocoder = new google.maps.Geocoder();
        }
        // Default fields value if no provided.
        if (!options.fields) {
          options.fields = ['address_component', 'formatted_address', 'name', 'url', 'geometry'];
        }
      }
    }
    ngAfterViewInit() {
      if (google) {
        const autocomplete = new google.maps.places.Autocomplete(this.addressAutocomplete.nativeElement, this.options);
        google.maps.event.addListener(autocomplete, 'place_changed', () => this.placeChanged(autocomplete));
      }
    }
    placeChanged(autocomplete) {
      const place = CdsInputPlacesComponent.fromPlaceResult(autocomplete.getPlace());
      if (place) {
        this.value = place;
      } else {
        this.onError.emit(new Error(CdsInputPlacesError.INVALID_PLACE_FOUND));
      }
    }
    getLocation() {
      if (this.locationSupported) {
        if (!this.locationInProgress && !this.disabled) {
          this.locationInProgress = true;
          this.markedAsTouched();
          navigator.geolocation.getCurrentPosition(position => {
            const location = new google.maps.LatLng({
              lat: position.coords.latitude,
              lng: position.coords.longitude
            });
            this.geocoder.geocode({
              location
            }).then(r => {
              const place = CdsInputPlacesComponent.fromPlaceResult(r.results[0]);
              if (place) {
                this.address = r.results[0].formatted_address;
                this.value = place;
              } else {
                this.onError.emit(new Error(CdsInputPlacesError.INVALID_PLACE_FOUND));
              }
            }).catch(_ => {
              this.onError.emit(new Error(CdsInputPlacesError.UNKNOWN));
            }).finally(() => this.locationInProgress = false);
          }, error => {
            switch (error.code) {
              case GeolocationPositionError.PERMISSION_DENIED:
                this.onError.emit(new Error(CdsInputPlacesError.PERMISSION_DENIED));
                break;
              case GeolocationPositionError.POSITION_UNAVAILABLE:
              case GeolocationPositionError.TIMEOUT:
                this.onError.emit(new Error(CdsInputPlacesError.POSITION_UNAVAILABLE));
                break;
              default:
                this.onError.emit(new Error(CdsInputPlacesError.UNKNOWN));
            }
            this.locationInProgress = false;
          });
        }
      } else {
        // Should not happen as we don't show button when not needed.
      }
    }
    markedAsTouched() {
      if (!this.touched) {
        this.onTouched();
        this.touched = true;
      }
    }
    static placeToAddress(place) {
      return place ? [place.name, place.address, place.zipCode, place.city].filter(Boolean).join(' ') : undefined;
    }
    static fromPlaceResult(place) {
      const streetNumber = place.address_components?.find(c => c.types.includes('street_number'))?.short_name;
      let address = place.address_components?.find(c => c.types.includes('route'))?.short_name;
      // https://ca-rool.atlassian.net/browse/TAP-1351
      if (!address) {
        address = place.formatted_address?.substring(0, place.formatted_address?.indexOf(','));
      }
      const city = place.address_components?.find(c => c.types.includes('locality'))?.short_name;
      const zipCode = place.address_components?.find(c => c.types.includes('postal_code'))?.short_name;
      const lat = place.geometry?.location?.lat();
      const lng = place.geometry?.location?.lng();
      const location = {
        lat,
        lng
      };
      if (address && city && zipCode) {
        const fAddress = streetNumber || address ? [streetNumber, address].filter(Boolean).join(' ') : undefined;
        const cdsPlace = {
          address: fAddress,
          city,
          zipCode,
          location
        };
        cdsPlace.name = place.name;
        cdsPlace.url = place.url;
        return cdsPlace;
      } else {
        return undefined;
      }
    }
    static {
      this.ɵfac = function CdsInputPlacesComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CdsInputPlacesComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CdsInputPlacesComponent,
        selectors: [["cds-input-places"]],
        viewQuery: function CdsInputPlacesComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.addressAutocomplete = _t.first);
          }
        },
        inputs: {
          options: "options",
          placeholder: "placeholder"
        },
        outputs: {
          onError: "onError"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          multi: true,
          useExisting: CdsInputPlacesComponent
        }]), i0.ɵɵNgOnChangesFeature],
        decls: 5,
        vars: 5,
        consts: [["addressAutocomplete", ""], ["inProgress", ""], [1, "cds-input"], [1, "cds-places-icon", 3, "name"], ["type", "text", 3, "ngModelChange", "placeholder", "ngModel", "disabled"], ["class", "cds-locate-me-container", 3, "click", 4, "ngIf"], [1, "cds-locate-me-container", 3, "click"], [4, "ngIf", "ngIfElse"], ["id", "icon", "name", "my_location"], ["class", "cds-my-location", 4, "ngIf"], [1, "cds-my-location"], [1, "pulse"]],
        template: function CdsInputPlacesComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 2);
            i0.ɵɵelement(1, "cds-svg-icon", 3);
            i0.ɵɵelementStart(2, "input", 4, 0);
            i0.ɵɵlistener("ngModelChange", function CdsInputPlacesComponent_Template_input_ngModelChange_2_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.markedAsTouched());
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(4, CdsInputPlacesComponent_div_4_Template, 4, 2, "div", 5);
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("name", "search");
            i0.ɵɵadvance();
            i0.ɵɵproperty("placeholder", ctx.placeholder)("ngModel", ctx.address)("disabled", ctx.disabled || ctx.locationInProgress);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", (ctx.options == null ? null : ctx.options.locateMe == null ? null : ctx.options.locateMe.enabled) && ctx.locationSupported);
          }
        },
        dependencies: [CdsSvgIconComponent, FormsModule, i1.DefaultValueAccessor, i1.NgControlStatus, i1.NgModel, NgIf],
        styles: [".cds-input[_ngcontent-%COMP%]{padding-left:50px}.cds-input[_ngcontent-%COMP%]   .cds-places-icon[_ngcontent-%COMP%]{position:absolute;width:16px;height:auto;left:24px}.cds-locate-me-container[_ngcontent-%COMP%]{display:flex;align-items:center;margin-top:16px;cursor:pointer}.cds-locate-me-container[_ngcontent-%COMP%]   .cds-my-location[_ngcontent-%COMP%]{color:var(--primary-palette-500);margin-left:8px;font-size:.75rem;font-weight:700}.pulse[_ngcontent-%COMP%]{width:16px;height:16px;border-radius:50%;background:var(--primary-palette-500);transform:scale(1);animation:_ngcontent-%COMP%_pulse 2s infinite}@keyframes _ngcontent-%COMP%_pulse{0%{transform:scale(.5)}70%{transform:scale(1.1)}to{transform:scale(.5)}}"]
      });
    }
  }
  return CdsInputPlacesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CdsCheckboxComponent = /*#__PURE__*/(() => {
  class CdsCheckboxComponent {
    constructor() {
      this.checked = input(false);
      this.disabled = input(false);
      this._value = this.checked();
      // Methods to implements control value accessor
      this.propagateChange = _ => {};
    }
    get value() {
      return this._value;
    }
    set value(v) {
      if (v !== this._value) {
        this._value = v;
        this.propagateChange(this._value);
      }
    }
    writeValue(obj) {
      this.value = obj;
    }
    registerOnChange(fn) {
      this.propagateChange = fn;
    }
    registerOnTouched(fn) {}
    setDisabledState(isDisabled) {}
    ngOnInit() {}
    onChange(event) {
      this.value = event.target.checked;
    }
    static {
      this.ɵfac = function CdsCheckboxComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CdsCheckboxComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CdsCheckboxComponent,
        selectors: [["cds-checkbox"]],
        inputs: {
          checked: [1, "checked"],
          disabled: [1, "disabled"]
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          multi: true,
          useExisting: CdsCheckboxComponent
        }])],
        ngContentSelectors: _c1,
        decls: 7,
        vars: 3,
        consts: [["checkbox", ""], [1, "cds-checkbox-container"], [1, "cds-checkbox-square"], ["id", "checkbox", "type", "checkbox", 3, "change", "checked", "disabled"], ["viewBox", "0 0 12 11", "focusable", "false", 1, "checked-icon"], ["for", "checkbox", 1, "cds-checkbox-label"], ["viewBox", "0 0 12 11", "focusable", "false", 1, "checked-icon", 3, "click"], ["d", "M10.1347 0.81882C10.3421 0.612066 10.618 0.497764 10.9043 0.500033C11.1906 0.502302 11.4649 0.620964 11.6692 0.83098C11.8736 1.041 11.992 1.32594 11.9996 1.62569C12.0072 1.92543 11.9033 2.21653 11.7098 2.43756L5.83628 10.1305C5.73529 10.2444 5.61339 10.3358 5.47788 10.3993C5.34238 10.4627 5.19604 10.4969 5.04763 10.4998C4.89922 10.5027 4.75177 10.4742 4.61412 10.416C4.47646 10.3579 4.35141 10.2712 4.24646 10.1613L0.351393 6.08205C0.242921 5.9762 0.15592 5.84855 0.095577 5.70672C0.0352345 5.56489 0.00278735 5.41178 0.000171818 5.25653C-0.00244371 5.10128 0.024826 4.94707 0.0803535 4.80309C0.135881 4.65912 0.218529 4.52834 0.323367 4.41854C0.428205 4.30875 0.553086 4.22219 0.690558 4.16404C0.828031 4.10588 0.97528 4.07732 1.12352 4.08006C1.27176 4.0828 1.41796 4.11678 1.55338 4.17998C1.68881 4.24318 1.8107 4.33429 1.91177 4.44789L4.99426 7.67459L10.1067 0.852737C10.1159 0.840868 10.1258 0.829544 10.1362 0.81882H10.1347Z"]],
        template: function CdsCheckboxComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "input", 3, 0);
            i0.ɵɵlistener("change", function CdsCheckboxComponent_Template_input_change_2_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onChange($event));
            });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, CdsCheckboxComponent_Conditional_4_Template, 2, 0, ":svg:svg", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "label", 5);
            i0.ɵɵprojection(6);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            const checkbox_r3 = i0.ɵɵreference(3);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("checked", ctx.value)("disabled", ctx.disabled());
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(checkbox_r3.checked ? 4 : -1);
          }
        },
        styles: [".cds-checkbox-container{display:flex;flex-flow:row nowrap;align-items:center}.cds-checkbox-container:has(input:disabled){opacity:.5}.cds-checkbox-container .cds-checkbox-square{position:relative;width:16px;height:16px;cursor:pointer;display:flex}.cds-checkbox-container .cds-checkbox-square input[type=checkbox]{width:inherit;height:inherit;border-radius:4px;border:solid 1px var(--primary-palette-500);margin:0;cursor:inherit}.cds-checkbox-container .cds-checkbox-square input[type=checkbox]:checked{background-color:var(--primary-palette-500);border:none}.cds-checkbox-container .cds-checkbox-square input[type=checkbox]:disabled{cursor:initial;border-color:#d3d3d3}.cds-checkbox-container .cds-checkbox-square .checked-icon{width:12px;height:11px;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);cursor:inherit;fill:var(--primary-palette-contrast-500)}.cds-checkbox-container .cds-checkbox-label{margin-left:8px;color:var(--accent-palette-contrast-500);font-size:1em;line-height:1em}\n"],
        encapsulation: 2
      });
    }
  }
  return CdsCheckboxComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var CdsOrientation = /*#__PURE__*/function (CdsOrientation) {
  CdsOrientation["HORIZONTAL"] = "HORIZONTAL";
  CdsOrientation["VERTICAL"] = "VERTICAL";
  return CdsOrientation;
}(CdsOrientation || {});
let CdsProgressBarComponent = /*#__PURE__*/(() => {
  class CdsProgressBarComponent {
    constructor() {
      this.orientation = CdsOrientation.VERTICAL;
      this.CdsOrientation = CdsOrientation;
      this.result = new EventEmitter();
      this.percentage = "0%";
      this.choices = [];
      this.selected = 0;
      // Methods to implements control value accessor
      this.propagateChange = _ => {};
    }
    get value() {
      return this._value;
    }
    set value(v) {
      if (v !== this._value) {
        this._value = v;
        this.propagateChange(this._value);
        if (v != null) {
          let index = this.choices.findIndex(el => el.value === v);
          if (index > -1) {
            this.clickOnCircle(index + 1);
          }
        }
      }
    }
    writeValue(obj) {
      this.value = obj;
    }
    registerOnChange(fn) {
      this.propagateChange = fn;
    }
    registerOnTouched(fn) {}
    setDisabledState(isDisabled) {}
    ngOnInit() {
      this.percentage = this.orientation === CdsOrientation.VERTICAL ? "100%" : "0%";
      this.selected = this.orientation === CdsOrientation.VERTICAL ? this.choices.length + 1 : 0;
    }
    clickOnCircle(id) {
      this.percentage = (id - 1) * Math.floor(100 / (this.choices.length - 1)) + '%';
      this.selected = id;
      this.value = this.choices[id - 1].value;
    }
    isOver(index, selected, orientation) {
      return orientation === CdsOrientation.VERTICAL ? index + 1 >= selected : index + 1 <= selected;
    }
    static {
      this.ɵfac = function CdsProgressBarComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CdsProgressBarComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CdsProgressBarComponent,
        selectors: [["cds-progress-bar"]],
        inputs: {
          choices: "choices"
        },
        outputs: {
          result: "result"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          multi: true,
          useExisting: CdsProgressBarComponent
        }])],
        decls: 5,
        vars: 6,
        consts: [[1, "container", 3, "ngClass"], [1, "progress"], [1, "progress-bar"], [1, "box"], ["class", "circle", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], [1, "circle", 3, "click", "ngClass"], [1, "choice"]],
        template: function CdsProgressBarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵelement(2, "div", 2);
            i0.ɵɵelementStart(3, "div", 3);
            i0.ɵɵtemplate(4, CdsProgressBarComponent_span_4_Template, 3, 5, "span", 4);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.orientation.toLowerCase());
            i0.ɵɵadvance(2);
            i0.ɵɵstyleProp("height", ctx.orientation === ctx.CdsOrientation.VERTICAL ? ctx.percentage : "100%")("width", ctx.orientation === ctx.CdsOrientation.HORIZONTAL ? ctx.percentage : "100%");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.choices);
          }
        },
        dependencies: [NgClass, NgForOf],
        styles: ["[_nghost-%COMP%]{min-height:200px;height:100%}.container[_ngcontent-%COMP%]{position:relative;display:flex;align-items:center}.container.horizontal[_ngcontent-%COMP%]{height:60px}.container.horizontal[_ngcontent-%COMP%]   .progress[_ngcontent-%COMP%], .container.horizontal[_ngcontent-%COMP%]   .progress-bar[_ngcontent-%COMP%]{width:100%;max-width:100%;height:8px}.container.horizontal[_ngcontent-%COMP%]   .progress[_ngcontent-%COMP%]{background:var(--accent-palette-contrast-500)}.container.horizontal[_ngcontent-%COMP%]   .progress-bar[_ngcontent-%COMP%]{background-color:var(--primary-palette-500);overflow:hidden;z-index:10;border-radius:8px;-moz-transition:width .2s linear;-webkit-transition:width .2s linear;-o-transition:width .2s linear;transition:width .2s linear}.container.horizontal[_ngcontent-%COMP%]   .box[_ngcontent-%COMP%]{position:absolute;top:50%;transform:translateY(-50%);width:100%;display:flex;justify-content:space-between}.container.vertical[_ngcontent-%COMP%]{flex-direction:column;width:60px;height:inherit}.container.vertical[_ngcontent-%COMP%]   .progress[_ngcontent-%COMP%], .container.vertical[_ngcontent-%COMP%]   .progress-bar[_ngcontent-%COMP%]{height:100%;max-height:100%;width:4px}.container.vertical[_ngcontent-%COMP%]   .progress[_ngcontent-%COMP%]{background:var(--primary-palette-500)}.container.vertical[_ngcontent-%COMP%]   .progress-bar[_ngcontent-%COMP%]{overflow:hidden;z-index:10;border-radius:8px;-moz-transition:height .2s linear;-webkit-transition:height .2s linear;-o-transition:height .2s linear;transition:height .2s linear}.container.vertical[_ngcontent-%COMP%]   .box[_ngcontent-%COMP%]{position:absolute;top:0;left:50%;transform:translate(-50%);display:flex;height:100%;flex-direction:column;justify-content:space-between}.progress[_ngcontent-%COMP%]{z-index:5;border-radius:20px}.choice[_ngcontent-%COMP%]{color:var(--accent-palette-contrast-500);position:absolute;left:48px;width:200px;font-weight:700;transform:translateY(-50%);top:50%;font-size:.75em}.circle[_ngcontent-%COMP%]{height:16px;width:16px;border-radius:50%;display:inline-block;align-self:center;z-index:15;position:relative}.selected[_ngcontent-%COMP%]{height:24px;width:24px}.selected[_ngcontent-%COMP%]   .choice[_ngcontent-%COMP%]{left:53px}.over[_ngcontent-%COMP%]{background-color:var(--primary-palette-500)}"]
      });
    }
  }
  return CdsProgressBarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class StringUtils {
  static containsArabic(s) {
    const arabicRegex = /[\u0600-\u06FF]/;
    return arabicRegex.test(s);
  }
}
let CdsBadgeInfoComponent = /*#__PURE__*/(() => {
  class CdsBadgeInfoComponent {
    constructor() {
      this.text = input.required();
      this.iconName = input();
      this.color = input('primary');
      this.direction = computed(() => StringUtils.containsArabic(this.text()) ? 'rtl' : 'ltr');
    }
    static {
      this.ɵfac = function CdsBadgeInfoComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CdsBadgeInfoComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CdsBadgeInfoComponent,
        selectors: [["cds-badge-info"]],
        inputs: {
          text: [1, "text"],
          iconName: [1, "iconName"],
          color: [1, "color"]
        },
        decls: 4,
        vars: 4,
        consts: [[1, "cds-badge-info-container", 3, "ngClass"], [1, "cds-badge-info-icon", 3, "name"], [1, "cds-badge-info-text", 3, "dir"]],
        template: function CdsBadgeInfoComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, CdsBadgeInfoComponent_Conditional_1_Template, 1, 1, "cds-svg-icon", 1);
            i0.ɵɵelementStart(2, "span", 2);
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            let tmp_1_0;
            i0.ɵɵproperty("ngClass", ctx.color());
            i0.ɵɵadvance();
            i0.ɵɵconditional((tmp_1_0 = ctx.iconName()) ? 1 : -1, tmp_1_0);
            i0.ɵɵadvance();
            i0.ɵɵproperty("dir", ctx.direction());
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.text());
          }
        },
        dependencies: [CommonModule, i1$1.NgClass, CdsSvgIconComponent],
        styles: [".cds-badge-info-container[_ngcontent-%COMP%]{display:inline-flex;align-items:center;border-style:solid;border-width:1px;border-radius:6px;padding:.5rem 1rem}.cds-badge-info-icon[_ngcontent-%COMP%]{margin-right:.5rem;width:1.25rem}.cds-badge-info-text[_ngcontent-%COMP%]{font-size:1rem;line-height:130%;font-weight:700}.primary.cds-badge-info-container[_ngcontent-%COMP%]{background:var(--primary-palette-500);border-color:var(--accent-palette-500)}.primary.cds-badge-info-container[_ngcontent-%COMP%]   .cds-badge-info-text[_ngcontent-%COMP%]{color:var(--accent-palette-500)}.accent.cds-badge-info-container[_ngcontent-%COMP%]{background:var(--accent-palette-500);border-color:var(--primary-palette-500)}.accent.cds-badge-info-container[_ngcontent-%COMP%]   .cds-badge-info-text[_ngcontent-%COMP%]{color:var(--primary-palette-500)}.accent-contrast.cds-badge-info-container[_ngcontent-%COMP%]{background:var(--accent-palette-500);border-color:var(--accent-palette-contrast-500)}.accent-contrast.cds-badge-info-container[_ngcontent-%COMP%]   .cds-badge-info-text[_ngcontent-%COMP%]{color:var(--accent-palette-contrast-500)}"]
      });
    }
  }
  return CdsBadgeInfoComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class Country {
  constructor(countryIso, direction = 'ltr') {
    this.direction = 'ltr';
    this.countryISO = countryIso;
    this.direction = direction;
  }
  static {
    this.Afghanistan = new Country('af');
  }
  static {
    this.Albania = new Country('al');
  }
  static {
    this.Algeria = new Country('dz', 'rtl');
  }
  static {
    this.AmericanSamoa = new Country('as');
  }
  static {
    this.Andorra = new Country('ad');
  }
  static {
    this.Angola = new Country('ao');
  }
  static {
    this.Anguilla = new Country('ai');
  }
  static {
    this.AntiguaAndBarbuda = new Country('ag');
  }
  static {
    this.Argentina = new Country('ar');
  }
  static {
    this.Armenia = new Country('am');
  }
  static {
    this.Aruba = new Country('aw');
  }
  static {
    this.Australia = new Country('au');
  }
  static {
    this.Austria = new Country('at');
  }
  static {
    this.Azerbaijan = new Country('az', 'rtl');
  }
  static {
    this.Bahamas = new Country('bs');
  }
  static {
    this.Bahrain = new Country('bh', 'rtl');
  }
  static {
    this.Bangladesh = new Country('bd');
  }
  static {
    this.Barbados = new Country('bb');
  }
  static {
    this.Belarus = new Country('by');
  }
  static {
    this.Belgium = new Country('be');
  }
  static {
    this.Belize = new Country('bz');
  }
  static {
    this.Benin = new Country('bj');
  }
  static {
    this.Bermuda = new Country('bm');
  }
  static {
    this.Bhutan = new Country('bt');
  }
  static {
    this.Bolivia = new Country('bo');
  }
  static {
    this.BosniaAndHerzegovina = new Country('ba');
  }
  static {
    this.Botswana = new Country('bw');
  }
  static {
    this.Brazil = new Country('br');
  }
  static {
    this.BritishIndianOceanTerritory = new Country('io');
  }
  static {
    this.BritishVirginIslands = new Country('vg');
  }
  static {
    this.Brunei = new Country('bn');
  }
  static {
    this.Bulgaria = new Country('bg');
  }
  static {
    this.BurkinaFaso = new Country('bf');
  }
  static {
    this.Burundi = new Country('bi');
  }
  static {
    this.Cambodia = new Country('kh');
  }
  static {
    this.Cameroon = new Country('cm');
  }
  static {
    this.Canada = new Country('ca');
  }
  static {
    this.CapeVerde = new Country('cv');
  }
  static {
    this.CaribbeanNetherlands = new Country('bq');
  }
  static {
    this.CaymanIslands = new Country('ky');
  }
  static {
    this.CentralAfricanRepublic = new Country('cf');
  }
  static {
    this.Chad = new Country('td');
  }
  static {
    this.Chile = new Country('cl');
  }
  static {
    this.China = new Country('cn');
  }
  static {
    this.ChristmasIsland = new Country('cx');
  }
  static {
    this.Cocos = new Country('cc');
  }
  static {
    this.Colombia = new Country('co');
  }
  static {
    this.Comoros = new Country('km', 'rtl');
  }
  static {
    this.CongoDRCJamhuriYaKidemokrasiaYaKongo = new Country('cd');
  }
  static {
    this.CongoRepublicCongoBrazzaville = new Country('cg');
  }
  static {
    this.CookIslands = new Country('ck');
  }
  static {
    this.CostaRica = new Country('cr');
  }
  static {
    this.CôteDIvoire = new Country('ci');
  }
  static {
    this.Croatia = new Country('hr');
  }
  static {
    this.Cuba = new Country('cu');
  }
  static {
    this.Curaçao = new Country('cw');
  }
  static {
    this.Cyprus = new Country('cy');
  }
  static {
    this.CzechRepublic = new Country('cz');
  }
  static {
    this.Denmark = new Country('dk');
  }
  static {
    this.Djibouti = new Country('dj', 'rtl');
  }
  static {
    this.Dominica = new Country('dm');
  }
  static {
    this.DominicanRepublic = new Country('do');
  }
  static {
    this.Ecuador = new Country('ec');
  }
  static {
    this.Egypt = new Country('eg', 'rtl');
  }
  static {
    this.ElSalvador = new Country('sv');
  }
  static {
    this.EquatorialGuinea = new Country('gq');
  }
  static {
    this.Eritrea = new Country('er', 'rtl');
  }
  static {
    this.Estonia = new Country('ee');
  }
  static {
    this.Ethiopia = new Country('et');
  }
  static {
    this.FalklandIslands = new Country('fk');
  }
  static {
    this.FaroeIslands = new Country('fo');
  }
  static {
    this.Fiji = new Country('fj');
  }
  static {
    this.Finland = new Country('fi');
  }
  static {
    this.France = new Country('fr');
  }
  static {
    this.FrenchGuiana = new Country('gf');
  }
  static {
    this.FrenchPolynesia = new Country('pf');
  }
  static {
    this.Gabon = new Country('ga');
  }
  static {
    this.Gambia = new Country('gm');
  }
  static {
    this.Georgia = new Country('ge');
  }
  static {
    this.Germany = new Country('de');
  }
  static {
    this.Ghana = new Country('gh');
  }
  static {
    this.Gibraltar = new Country('gi');
  }
  static {
    this.Greece = new Country('gr');
  }
  static {
    this.Greenland = new Country('gl');
  }
  static {
    this.Grenada = new Country('gd');
  }
  static {
    this.Guadeloupe = new Country('gp');
  }
  static {
    this.Guam = new Country('gu');
  }
  static {
    this.Guatemala = new Country('gt');
  }
  static {
    this.Guernsey = new Country('gg');
  }
  static {
    this.Guinea = new Country('gn');
  }
  static {
    this.GuineaBissau = new Country('gw');
  }
  static {
    this.Guyana = new Country('gy');
  }
  static {
    this.Haiti = new Country('ht');
  }
  static {
    this.Honduras = new Country('hn');
  }
  static {
    this.HongKong = new Country('hk');
  }
  static {
    this.Hungary = new Country('hu');
  }
  static {
    this.Iceland = new Country('is');
  }
  static {
    this.India = new Country('in');
  }
  static {
    this.Indonesia = new Country('id');
  }
  static {
    this.Iran = new Country('ir');
  }
  static {
    this.Iraq = new Country('iq', 'rtl');
  }
  static {
    this.Ireland = new Country('ie');
  }
  static {
    this.IsleOfMan = new Country('im');
  }
  static {
    this.Israel = new Country('il', 'rtl');
  }
  static {
    this.Italy = new Country('it');
  }
  static {
    this.Jamaica = new Country('jm');
  }
  static {
    this.Japan = new Country('jp');
  }
  static {
    this.Jersey = new Country('je');
  }
  static {
    this.Jordan = new Country('jo', 'rtl');
  }
  static {
    this.Kazakhstan = new Country('kz');
  }
  static {
    this.Kenya = new Country('ke');
  }
  static {
    this.Kiribati = new Country('ki');
  }
  static {
    this.Kosovo = new Country('xk');
  }
  static {
    this.Kuwait = new Country('kw', 'rtl');
  }
  static {
    this.Kyrgyzstan = new Country('kg');
  }
  static {
    this.Laos = new Country('la');
  }
  static {
    this.Latvia = new Country('lv');
  }
  static {
    this.Lebanon = new Country('lb', 'rtl');
  }
  static {
    this.Lesotho = new Country('ls');
  }
  static {
    this.Liberia = new Country('lr');
  }
  static {
    this.Libya = new Country('ly', 'rtl');
  }
  static {
    this.Liechtenstein = new Country('li');
  }
  static {
    this.Lithuania = new Country('lt');
  }
  static {
    this.Luxembourg = new Country('lu');
  }
  static {
    this.Macau = new Country('mo');
  }
  static {
    this.Macedonia = new Country('mk');
  }
  static {
    this.Madagascar = new Country('mg');
  }
  static {
    this.Malawi = new Country('mw');
  }
  static {
    this.Malaysia = new Country('my');
  }
  static {
    this.Maldives = new Country('mv');
  }
  static {
    this.Mali = new Country('ml');
  }
  static {
    this.Malta = new Country('mt');
  }
  static {
    this.MarshallIslands = new Country('mh');
  }
  static {
    this.Martinique = new Country('mq');
  }
  static {
    this.Mauritania = new Country('mr', 'rtl');
  }
  static {
    this.Mauritius = new Country('mu');
  }
  static {
    this.Mayotte = new Country('yt');
  }
  static {
    this.Mexico = new Country('mx');
  }
  static {
    this.Micronesia = new Country('fm');
  }
  static {
    this.Moldova = new Country('md');
  }
  static {
    this.Monaco = new Country('mc');
  }
  static {
    this.Mongolia = new Country('mn');
  }
  static {
    this.Montenegro = new Country('me');
  }
  static {
    this.Montserrat = new Country('ms');
  }
  static {
    this.Morocco = new Country('ma', 'rtl');
  }
  static {
    this.Mozambique = new Country('mz');
  }
  static {
    this.Myanmar = new Country('mm');
  }
  static {
    this.Namibia = new Country('na');
  }
  static {
    this.Nauru = new Country('nr');
  }
  static {
    this.Nepal = new Country('np');
  }
  static {
    this.Netherlands = new Country('nl');
  }
  static {
    this.NewCaledonia = new Country('nc');
  }
  static {
    this.NewZealand = new Country('nz');
  }
  static {
    this.Nicaragua = new Country('ni');
  }
  static {
    this.Niger = new Country('ne');
  }
  static {
    this.Nigeria = new Country('ng');
  }
  static {
    this.Niue = new Country('nu');
  }
  static {
    this.NorfolkIsland = new Country('nf');
  }
  static {
    this.NorthKorea = new Country('kp');
  }
  static {
    this.NorthernMarianaIslands = new Country('mp');
  }
  static {
    this.Norway = new Country('no');
  }
  static {
    this.Oman = new Country('om', 'rtl');
  }
  static {
    this.Pakistan = new Country('pk');
  }
  static {
    this.Palau = new Country('pw');
  }
  static {
    this.Palestine = new Country('ps');
  }
  static {
    this.Panama = new Country('pa');
  }
  static {
    this.PapuaNewGuinea = new Country('pg');
  }
  static {
    this.Paraguay = new Country('py');
  }
  static {
    this.Peru = new Country('pe');
  }
  static {
    this.Philippines = new Country('ph');
  }
  static {
    this.Poland = new Country('pl');
  }
  static {
    this.Portugal = new Country('pt');
  }
  static {
    this.PuertoRico = new Country('pr');
  }
  static {
    this.Qatar = new Country('qa', 'rtl');
  }
  static {
    this.Réunion = new Country('re');
  }
  static {
    this.Romania = new Country('ro');
  }
  static {
    this.Russia = new Country('ru');
  }
  static {
    this.Rwanda = new Country('rw');
  }
  static {
    this.SaintBarthélemy = new Country('bl');
  }
  static {
    this.SaintHelena = new Country('sh');
  }
  static {
    this.SaintKittsAndNevis = new Country('kn');
  }
  static {
    this.SaintLucia = new Country('lc');
  }
  static {
    this.SaintMartin = new Country('mf');
  }
  static {
    this.SaintPierreAndMiquelon = new Country('pm');
  }
  static {
    this.SaintVincentAndTheGrenadines = new Country('vc');
  }
  static {
    this.Samoa = new Country('ws');
  }
  static {
    this.SanMarino = new Country('sm');
  }
  static {
    this.SãoToméAndPríncipe = new Country('st');
  }
  static {
    this.SaudiArabia = new Country('sa', 'rtl');
  }
  static {
    this.Senegal = new Country('sn');
  }
  static {
    this.Serbia = new Country('rs');
  }
  static {
    this.Seychelles = new Country('sc');
  }
  static {
    this.SierraLeone = new Country('sl');
  }
  static {
    this.Singapore = new Country('sg');
  }
  static {
    this.SintMaarten = new Country('sx');
  }
  static {
    this.Slovakia = new Country('sk');
  }
  static {
    this.Slovenia = new Country('si');
  }
  static {
    this.SolomonIslands = new Country('sb');
  }
  static {
    this.Somalia = new Country('so', 'rtl');
  }
  static {
    this.SouthAfrica = new Country('za');
  }
  static {
    this.SouthKorea = new Country('kr');
  }
  static {
    this.SouthSudan = new Country('ss', 'rtl');
  }
  static {
    this.Spain = new Country('es');
  }
  static {
    this.SriLanka = new Country('lk');
  }
  static {
    this.Sudan = new Country('sd', 'rtl');
  }
  static {
    this.Suriname = new Country('sr');
  }
  static {
    this.SvalbardAndJanMayen = new Country('sj');
  }
  static {
    this.Swaziland = new Country('sz');
  }
  static {
    this.Sweden = new Country('se');
  }
  static {
    this.Switzerland = new Country('ch');
  }
  static {
    this.Syria = new Country('sy', 'rtl');
  }
  static {
    this.Taiwan = new Country('tw');
  }
  static {
    this.Tajikistan = new Country('tj');
  }
  static {
    this.Tanzania = new Country('tz', 'rtl');
  }
  static {
    this.Thailand = new Country('th');
  }
  static {
    this.TimorLeste = new Country('tl');
  }
  static {
    this.Togo = new Country('tg');
  }
  static {
    this.Tokelau = new Country('tk');
  }
  static {
    this.Tonga = new Country('to');
  }
  static {
    this.TrinidadAndTobago = new Country('tt');
  }
  static {
    this.Tunisia = new Country('tn', 'rtl');
  }
  static {
    this.Turkey = new Country('tr');
  }
  static {
    this.Turkmenistan = new Country('tm');
  }
  static {
    this.TurksAndCaicosIslands = new Country('tc');
  }
  static {
    this.Tuvalu = new Country('tv');
  }
  static {
    this.USVirginIslands = new Country('vi');
  }
  static {
    this.Uganda = new Country('ug');
  }
  static {
    this.Ukraine = new Country('ua');
  }
  static {
    this.UnitedArabEmirates = new Country('ae', 'rtl');
  }
  static {
    this.UnitedKingdom = new Country('gb');
  }
  static {
    this.UnitedStates = new Country('us');
  }
  static {
    this.Uruguay = new Country('uy');
  }
  static {
    this.Uzbekistan = new Country('uz');
  }
  static {
    this.Vanuatu = new Country('vu');
  }
  static {
    this.VaticanCity = new Country('va');
  }
  static {
    this.Venezuela = new Country('ve');
  }
  static {
    this.Vietnam = new Country('vn');
  }
  static {
    this.WallisAndFutuna = new Country('wf');
  }
  static {
    this.WesternSahara = new Country('eh');
  }
  static {
    this.Yemen = new Country('ye', 'rtl');
  }
  static {
    this.Zambia = new Country('zm');
  }
  static {
    this.Zimbabwe = new Country('zw');
  }
  static {
    this.ÅlandIslands = new Country('ax');
  }
  static {
    this.ALL = [Country.Afghanistan, Country.Albania, Country.Algeria, Country.AmericanSamoa, Country.Andorra, Country.Angola, Country.Anguilla, Country.AntiguaAndBarbuda, Country.Argentina, Country.Armenia, Country.Aruba, Country.Australia, Country.Austria, Country.Azerbaijan, Country.Bahamas, Country.Bahrain, Country.Bangladesh, Country.Barbados, Country.Belarus, Country.Belgium, Country.Belize, Country.Benin, Country.Bermuda, Country.Bhutan, Country.Bolivia, Country.BosniaAndHerzegovina, Country.Botswana, Country.Brazil, Country.BritishIndianOceanTerritory, Country.BritishVirginIslands, Country.Brunei, Country.Bulgaria, Country.BurkinaFaso, Country.Burundi, Country.Cambodia, Country.Cameroon, Country.Canada, Country.CapeVerde, Country.CaribbeanNetherlands, Country.CaymanIslands, Country.CentralAfricanRepublic, Country.Chad, Country.Chile, Country.China, Country.ChristmasIsland, Country.Cocos, Country.Colombia, Country.Comoros, Country.CongoDRCJamhuriYaKidemokrasiaYaKongo, Country.CongoRepublicCongoBrazzaville, Country.CookIslands, Country.CostaRica, Country.CôteDIvoire, Country.Croatia, Country.Cuba, Country.Curaçao, Country.Cyprus, Country.CzechRepublic, Country.Denmark, Country.Djibouti, Country.Dominica, Country.DominicanRepublic, Country.Ecuador, Country.Egypt, Country.ElSalvador, Country.EquatorialGuinea, Country.Eritrea, Country.Estonia, Country.Ethiopia, Country.FalklandIslands, Country.FaroeIslands, Country.Fiji, Country.Finland, Country.France, Country.FrenchGuiana, Country.FrenchPolynesia, Country.Gabon, Country.Gambia, Country.Georgia, Country.Germany, Country.Ghana, Country.Gibraltar, Country.Greece, Country.Greenland, Country.Grenada, Country.Guadeloupe, Country.Guam, Country.Guatemala, Country.Guernsey, Country.Guinea, Country.GuineaBissau, Country.Guyana, Country.Haiti, Country.Honduras, Country.HongKong, Country.Hungary, Country.Iceland, Country.India, Country.Indonesia, Country.Iran, Country.Iraq, Country.Ireland, Country.IsleOfMan, Country.Israel, Country.Italy, Country.Jamaica, Country.Japan, Country.Jersey, Country.Jordan, Country.Kazakhstan, Country.Kenya, Country.Kiribati, Country.Kosovo, Country.Kuwait, Country.Kyrgyzstan, Country.Laos, Country.Latvia, Country.Lebanon, Country.Lesotho, Country.Liberia, Country.Libya, Country.Liechtenstein, Country.Lithuania, Country.Luxembourg, Country.Macau, Country.Macedonia, Country.Madagascar, Country.Malawi, Country.Malaysia, Country.Maldives, Country.Mali, Country.Malta, Country.MarshallIslands, Country.Martinique, Country.Mauritania, Country.Mauritius, Country.Mayotte, Country.Mexico, Country.Micronesia, Country.Moldova, Country.Monaco, Country.Mongolia, Country.Montenegro, Country.Montserrat, Country.Morocco, Country.Mozambique, Country.Myanmar, Country.Namibia, Country.Nauru, Country.Nepal, Country.Netherlands, Country.NewCaledonia, Country.NewZealand, Country.Nicaragua, Country.Niger, Country.Nigeria, Country.Niue, Country.NorfolkIsland, Country.NorthKorea, Country.NorthernMarianaIslands, Country.Norway, Country.Oman, Country.Pakistan, Country.Palau, Country.Palestine, Country.Panama, Country.PapuaNewGuinea, Country.Paraguay, Country.Peru, Country.Philippines, Country.Poland, Country.Portugal, Country.PuertoRico, Country.Qatar, Country.Réunion, Country.Romania, Country.Russia, Country.Rwanda, Country.SaintBarthélemy, Country.SaintHelena, Country.SaintKittsAndNevis, Country.SaintLucia, Country.SaintMartin, Country.SaintPierreAndMiquelon, Country.SaintVincentAndTheGrenadines, Country.Samoa, Country.SanMarino, Country.SãoToméAndPríncipe, Country.SaudiArabia, Country.Senegal, Country.Serbia, Country.Seychelles, Country.SierraLeone, Country.Singapore, Country.SintMaarten, Country.Slovakia, Country.Slovenia, Country.SolomonIslands, Country.Somalia, Country.SouthAfrica, Country.SouthKorea, Country.SouthSudan, Country.Spain, Country.SriLanka, Country.Sudan, Country.Suriname, Country.SvalbardAndJanMayen, Country.Swaziland, Country.Sweden, Country.Switzerland, Country.Syria, Country.Taiwan, Country.Tajikistan, Country.Tanzania, Country.Thailand, Country.TimorLeste, Country.Togo, Country.Tokelau, Country.Tonga, Country.TrinidadAndTobago, Country.Tunisia, Country.Turkey, Country.Turkmenistan, Country.TurksAndCaicosIslands, Country.Tuvalu, Country.USVirginIslands, Country.Uganda, Country.Ukraine, Country.UnitedArabEmirates, Country.UnitedKingdom, Country.UnitedStates, Country.Uruguay, Country.Uzbekistan, Country.Vanuatu, Country.VaticanCity, Country.Venezuela, Country.Vietnam, Country.WallisAndFutuna, Country.WesternSahara, Country.Yemen, Country.Zambia, Country.Zimbabwe, Country.ÅlandIslands];
  }
  static getByIsoCode(isoCode) {
    return Country.ALL.find(c => c.countryISO === isoCode?.toLowerCase());
  }
}
let CdsInputLocalizedComponent = /*#__PURE__*/(() => {
  class CdsInputLocalizedComponent {
    get value() {
      return this._value;
    }
    set value(v) {
      if (v !== this._value) {
        if (v != null) {
          const country = this.countries().find(c => c.countryISO === v?.countryISO?.toLowerCase());
          if (country) {
            this.country = country;
            this.placeholderContainsArabic = !!(this.country.placeholder && StringUtils.containsArabic(this.country.placeholder));
            this._value = v;
            this._value.value = this._value?.value?.trim();
          }
        } else {
          this._value = v;
        }
        this.propagateChange(this._value);
        // Dispatch the event manually to also get the change event when country select value changes, default behavior only triggers for the text input
        if (this.component()) {
          const event = new Event('change', {
            'bubbles': true
          });
          this.component().nativeElement.value = this.value;
          this.component().nativeElement.dispatchEvent(event);
        }
      }
    }
    registerOnChange(fn) {
      this.propagateChange = fn;
    }
    writeValue(v) {
      this.value = v;
    }
    registerOnTouched(fn) {}
    setDisabledState(isDisabled) {
      this.disabled.set(isDisabled);
    }
    constructor(renderer) {
      this.renderer = renderer;
      this.component = viewChild('cdsLocalizedInput');
      this.disabled = model(false);
      this.countries = input([]);
      this.inputType = 'text';
      this.textCase = "default";
      this.selectOpen = false;
      this.expandable = computed(() => this.countries().length > 1 && !this.disabled());
      this.containsArabic = false;
      this.placeholderContainsArabic = false;
      this.clickListener = null;
      this.propagateChange = _ => {};
      this.onTouched = () => {};
      if (!this.clickListener) {
        this.clickListener = this.renderer.listen('window', 'click', e => {
          if (!this.component()?.nativeElement.contains(e.target)) {
            this.selectOpen = false;
          }
        });
      }
      effect(() => {
        this.countries().forEach(country => country.countryISO = country.countryISO.toLowerCase());
      });
    }
    ngOnInit() {
      if (this.value == null && this.defaultCountry) {
        this.country = this.defaultCountry;
        this.countryInfo = Country.getByIsoCode(this.country.countryISO);
        this.value = {
          value: this._value?.value,
          countryISO: this.country.countryISO
        };
      }
    }
    ngOnChanges(changes) {
      if (changes && changes['countries']) {
        this.country = this.countries()[0];
        this.countryInfo = Country.getByIsoCode(this.country.countryISO);
        this.placeholderContainsArabic = !!(this.country.placeholder && StringUtils.containsArabic(this.country.placeholder));
      }
    }
    onValueChange(event) {
      if (this.country) {
        const input = event.target.value;
        this.containsArabic = StringUtils.containsArabic(input);
        const license = this.applyTextCase(input, this.textCase);
        this.value = {
          value: license,
          countryISO: this.country.countryISO
        };
      }
    }
    onSelectedCountryClick() {
      if (this.expandable()) {
        this.selectOpen = !this.selectOpen;
        this.input.nativeElement.focus();
      }
    }
    onCountryChanged(country) {
      this.country = country;
      this.countryInfo = Country.getByIsoCode(this.country.countryISO);
      this.value = {
        value: this.value?.value,
        countryISO: this.country.countryISO
      };
      this.selectOpen = false;
      this.placeholderContainsArabic = !!(this.country.placeholder && StringUtils.containsArabic(this.country.placeholder));
    }
    // To prevent duplicate events because we already dispatch it manually
    handleDefaultChangeEvent($event) {
      $event.stopPropagation();
    }
    applyTextCase(text, textCase) {
      let fText = text;
      switch (textCase) {
        case "uppercase":
          fText = text.toUpperCase();
          break;
        case "lowercase":
          fText = text.toLowerCase();
          break;
      }
      this.input.nativeElement.value = fText;
      return fText;
    }
    static {
      this.ɵfac = function CdsInputLocalizedComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CdsInputLocalizedComponent)(i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CdsInputLocalizedComponent,
        selectors: [["cds-input-localized"]],
        viewQuery: function CdsInputLocalizedComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.component, _c3, 5);
            i0.ɵɵviewQuery(_c4, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.input = _t.first);
          }
        },
        inputs: {
          disabled: [1, "disabled"],
          countries: [1, "countries"],
          inputType: "inputType",
          defaultCountry: "defaultCountry",
          textCase: "textCase"
        },
        outputs: {
          disabled: "disabledChange"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          multi: true,
          useExisting: CdsInputLocalizedComponent
        }]), i0.ɵɵNgOnChangesFeature],
        decls: 1,
        vars: 1,
        consts: [["cdsLocalizedInput", ""], ["countryText", ""], ["input", ""], ["class", "cds-input-license", 4, "ngIf"], [1, "cds-input-license"], [1, "cds-input"], [1, "cds-selected-flag", 3, "click"], ["class", "cds-flag", 3, "src", "alt", 4, "ngIf", "ngIfElse"], [4, "ngIf"], [3, "ngClass", "name", 4, "ngIf"], [3, "input", "change", "value", "type", "dir", "placeholder", "disabled"], ["class", "cds-select", 4, "ngIf"], [1, "cds-flag", 3, "src", "alt"], [3, "ngClass", "name"], [1, "cds-select"], [3, "click", 4, "ngFor", "ngForOf"], [3, "click"], ["class", "cds-flag", 3, "src", "alt", 4, "ngIf"]],
        template: function CdsInputLocalizedComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CdsInputLocalizedComponent_div_0_Template, 12, 10, "div", 3);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.country);
          }
        },
        dependencies: [CommonModule, i1$1.NgClass, i1$1.NgForOf, i1$1.NgIf, CdsSvgIconComponent],
        styles: [".cds-input-license[_ngcontent-%COMP%]{position:relative}.cds-selected-flag[_ngcontent-%COMP%]{height:inherit;display:flex;align-items:center;padding:16px;cursor:pointer;border-right:solid 2px var(--accent-palette-500)}.cds-selected-flag[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin-right:4px;font-size:12px}.cds-selected-flag[_ngcontent-%COMP%]   cds-svg-icon[_ngcontent-%COMP%]{margin-bottom:2px;transition:all .3s ease-in-out}.cds-selected-flag[_ngcontent-%COMP%]   .open[_ngcontent-%COMP%]{transform:rotate(180deg)}.cds-select[_ngcontent-%COMP%]{position:absolute;z-index:1000;transform:translateY(0);border-bottom-left-radius:8px;border-bottom-right-radius:8px;overflow:auto;top:50px;font-size:.875rem;max-height:200px}.cds-select[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{margin:0;padding:0;display:flex;flex-flow:column nowrap}.cds-select[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{display:flex;align-items:center;color:var(--accent-palette-contrast-500);white-space:nowrap;cursor:pointer;padding:8px;gap:5px}.cds-select[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:hover{background:var(--accent-palette-500)}.cds-flag[_ngcontent-%COMP%]{width:20px;height:14px}.cds-flag[_ngcontent-%COMP%]:not(:last-child){margin-right:8px}"]
      });
    }
  }
  return CdsInputLocalizedComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class CdsPhoneValidation {
  static {
    this.phoneUtil = PhoneNumberUtil.getInstance();
  }
  static validatePhoneNumber(phoneNumber) {
    if (!phoneNumber?.value) return;
    if (!this.containsOnlyValidCharacters(phoneNumber.value)) return 'Character';
    const parsedNumber = this.parseNumber(phoneNumber);
    if (parsedNumber == undefined) return 'Parsing';
    if (!this.isPhoneNumberValid(parsedNumber)) return 'Invalid';
    if (!this.isCountryPrefixValid(phoneNumber)) return 'Prefix';
    return this.convertToE164(parsedNumber);
  }
  static containsOnlyValidCharacters(phoneNumber) {
    return /^[0-9+()-./\s]+$/.test(phoneNumber);
  }
  static isCountryPrefixValid(phoneNumber) {
    if (phoneNumber?.value?.startsWith('+')) {
      const prefix = this.phoneUtil.getCountryCodeForRegion(phoneNumber.countryISO).toString();
      if (prefix && phoneNumber.value.substring(1, prefix.length + 1) !== prefix) {
        return false;
      }
    }
    return true;
  }
  static isPhoneNumberValid(parsedNumber) {
    return this.phoneUtil.isPossibleNumber(parsedNumber) && this.phoneUtil.isValidNumber(parsedNumber);
  }
  static parseNumber(phoneNumber) {
    let number = new PhoneNumber();
    try {
      number = this.phoneUtil.parse(phoneNumber.value, phoneNumber.countryISO);
    } catch (_) {
      return undefined;
    }
    return number;
  }
  static convertToE164(number) {
    return this.phoneUtil.format(number, PhoneNumberFormat.E164);
  }
}
let CdsTelInputComponent = /*#__PURE__*/(() => {
  class CdsTelInputComponent {
    constructor() {
      this.countries = [];
      this.errorEvent = new EventEmitter();
      this.phoneUtil = PhoneNumberUtil.getInstance();
      this.component = viewChild.required('cdsTelInput');
      this.propagateChange = _ => {};
      this.onTouched = () => {};
    }
    get value() {
      return this._value;
    }
    set value(v) {
      this._value = v;
      this.unformattedValue = structuredClone(v);
      if (this._value) {
        const validation = CdsPhoneValidation.validatePhoneNumber(this._value);
        if (validation && !['Parsing', 'Prefix', 'Invalid', 'Character'].includes(validation)) {
          this._value.value = validation;
        }
      }
      this.propagateChange(this._value);
    }
    registerOnChange(fn) {
      this.propagateChange = fn;
    }
    writeValue(v) {
      this.value = v;
      if (this.component()) {
        this.component().writeValue(this.unformattedValue);
      }
    }
    ngAfterViewInit() {
      const matchedCountry = this.countries.find(country => country.countryCode?.toString() === this.unformattedValue?.value?.substring(1, country.countryCode?.toString().length));
      if (this.unformattedValue && matchedCountry) this.unformattedValue.countryISO = matchedCountry.countryISO;
      this.writeValue(this.unformattedValue);
    }
    registerOnTouched(fn) {}
    ngOnChanges(changes) {
      if (changes['countries'].currentValue) this.mapPrefixAndPlaceholderToCountries();
    }
    ngOnInit() {
      this.mapPrefixAndPlaceholderToCountries();
    }
    mapPrefixAndPlaceholderToCountries() {
      const doMapping = country => {
        country.countryCode = this.phoneUtil.getCountryCodeForRegion(country.countryISO);
        const exampleNumber = this.phoneUtil.getExampleNumberForType(country.countryISO, PhoneNumberType.MOBILE);
        country.placeholder = this.phoneUtil.format(exampleNumber, PhoneNumberFormat.NATIONAL);
      };
      this.countries.map(country => {
        doMapping(country);
      });
      if (this.defaultCountry) doMapping(this.defaultCountry);
    }
    onPhoneNumberChange($event) {
      // Otherwise native change event from input-localized bubbles up to the parent and we get a CdsLocalizedOutputValue instead of phone number
      $event.stopPropagation();
      const phoneNumber = $event.target.value;
      if (phoneNumber != this.unformattedValue) {
        const validation = CdsPhoneValidation.validatePhoneNumber(phoneNumber);
        if (!validation) {
          this.errorEvent.emit('');
          this.writeValue(undefined);
          return;
        }
        if (['Parsing', 'Prefix', 'Invalid', 'Character'].includes(validation)) {
          this.errorEvent.emit(validation);
          this.writeValue(phoneNumber);
          return;
        }
        this.errorEvent.emit('');
        this.writeValue(phoneNumber);
      }
    }
    static {
      this.ɵfac = function CdsTelInputComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CdsTelInputComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CdsTelInputComponent,
        selectors: [["cds-tel-input"]],
        viewQuery: function CdsTelInputComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.component, _c6, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          countries: "countries",
          defaultCountry: "defaultCountry"
        },
        outputs: {
          errorEvent: "errorEvent"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          multi: true,
          useExisting: CdsTelInputComponent
        }]), i0.ɵɵNgOnChangesFeature],
        decls: 2,
        vars: 3,
        consts: [["cdsTelInput", ""], [3, "change", "countries", "defaultCountry", "inputType"]],
        template: function CdsTelInputComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "cds-input-localized", 1, 0);
            i0.ɵɵlistener("change", function CdsTelInputComponent_Template_cds_input_localized_change_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onPhoneNumberChange($event));
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("countries", ctx.countries)("defaultCountry", ctx.defaultCountry)("inputType", "tel");
          }
        },
        dependencies: [CommonModule, CdsInputLocalizedComponent, ReactiveFormsModule],
        encapsulation: 2
      });
    }
  }
  return CdsTelInputComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function phoneNumberValidator() {
  return control => {
    const validate = CdsPhoneValidation.validatePhoneNumber(control?.value);
    if (!validate) {
      return null;
    }
    if (['Parsing', 'Prefix', 'Invalid', 'Character'].includes(validate)) return {
      [validate]: true
    };
    return null;
  };
}
function emailValidator() {
  return control => {
    const value = control.value;
    if (value == null || value.trim().length === 0) {
      return null;
    }
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const valid = emailRegex.test(value);
    return !valid ? {
      email: true
    } : null;
  };
}
const SELECTOR_CDS_CLASS_PAIR = [{
  selector: 'cdsButton',
  cdsClasses: ['cds-button']
}, {
  selector: 'cdsLinkButton',
  cdsClasses: ['cds-button', 'cds-link-button']
}];
let CdsButtonDirective = /*#__PURE__*/(() => {
  class CdsButtonDirective {
    constructor() {
      this.color = input('primary');
      this.size = input('small');
      this._elementRef = inject(ElementRef);
    }
    ngOnInit() {
      const classList = this._elementRef.nativeElement.classList;
      for (const pair of SELECTOR_CDS_CLASS_PAIR) {
        if (this._hasAttributes(pair.selector)) {
          pair.cdsClasses.forEach(className => {
            classList.add(className);
          });
          classList.add(`cds-button-${this.color()}`);
          if (pair.selector === 'cdsButton') {
            classList.add(`cds-button-${this.size()}`);
          }
        }
      }
    }
    _hasAttributes(...attributes) {
      return attributes.some(attribute => this._elementRef.nativeElement.hasAttribute(attribute));
    }
    static {
      this.ɵfac = function CdsButtonDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CdsButtonDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: CdsButtonDirective,
        inputs: {
          color: [1, "color"],
          size: [1, "size"]
        }
      });
    }
  }
  return CdsButtonDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CdsButtonComponent = /*#__PURE__*/(() => {
  class CdsButtonComponent extends CdsButtonDirective {
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵCdsButtonComponent_BaseFactory;
        return function CdsButtonComponent_Factory(__ngFactoryType__) {
          return (ɵCdsButtonComponent_BaseFactory || (ɵCdsButtonComponent_BaseFactory = i0.ɵɵgetInheritedFactory(CdsButtonComponent)))(__ngFactoryType__ || CdsButtonComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CdsButtonComponent,
        selectors: [["button", "cdsButton", ""], ["button", "cdsLinkButton", ""]],
        features: [i0.ɵɵInheritDefinitionFeature],
        attrs: _c7,
        ngContentSelectors: _c1,
        decls: 1,
        vars: 0,
        template: function CdsButtonComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return CdsButtonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ngx-carool-ds
 */
// Input places

/**
 * Generated bundle index. Do not edit.
 */

export { CdsBadgeInfoComponent, CdsButtonComponent, CdsButtonDirective, CdsCheckboxComponent, CdsInputLocalizedComponent, CdsInputPlacesComponent, CdsInputPlacesError, CdsOrientation, CdsProgressBarComponent, CdsSvgIconComponent, CdsTelInputComponent, Country, StringUtils, emailValidator, phoneNumberValidator };
